import React from 'react';
import PropTypes from 'prop-types';

import LoyaltyCTA from './loyaltyCTA';

export const schemes = ["DataCandyLoyalty", "SpoonityLoyalty", "ComoLoyalty"];

const LoyaltySelector = ({ schemeId }) => {
    if (!schemeId) return null;
    return <LoyaltyCTA loyalty={schemeId} />;
};

LoyaltySelector.propTypes = {
    schemeId: PropTypes.string.isRequired,
};

export default LoyaltySelector;
